import { ICrumbsDataSource } from '@app/ti-components/study-start-up/bread-crumbs/models/commonDataProtocol';

export enum BreadCrumbType {
  default = 'default',
  home = 'home',
  room = 'room',
  data = 'data',
  none = 'none',
  module = 'module',
  domainModule = 'domainModule',
  text = 'text',
}

export interface IBaseCrumb {
  title: string;
  header?: string;
  link: string;
  type: BreadCrumbType;
  keptQueryParams: string[];
  icon?: string;
}

export interface IDataCrumb extends IBaseCrumb {
  entityName: string;
  entityNameTooltip?: string;
  dataSource: ICrumbsDataSource;
  type: BreadCrumbType.data;
  moduleLink: string;
}

export interface IRoomCrumb extends IBaseCrumb {
  entityName: string;
  type: BreadCrumbType.room;
  moduleLink: string;
}

export type ICrumbsConfig = (IBaseCrumb & Partial<IRoomCrumb & IDataCrumb>) | IDataCrumb | IRoomCrumb;
